import template from './index.jst';
import './index.styl';
import { CoreLeagueInvitesView } from '../../../../../core/views';
import { redirectTo } from '../../../../../core/utils';

/**
 * @desc League Invites View Class
 * This class using on league loin page ('fantasy/league/:id/manage/invites')
 */
export default class CompInvitesView extends CoreLeagueInvitesView {

	get template() {
		return template;
	}

	get className() {
		return "league-invites-page shadow";
	}

	sendEmailInvites() {
		let data = {
			comp_id: this.model.get( 'id' ),
			invites:   this.emailLists
		};

		this.model.sendInvites( data );
	}

	checkCurrentUser() {
		if( !this.model
			.checkLeagueMember()
		) {
			this.redirectToMyLeague();
		}
	}

	getIviteLink() {
		let code = this.model.get( 'code' );
		return `https:${process.env.ABSPATH}comps/join?code=${code}`;
	}

	redirectToMyLeague() {
		redirectTo( '/comps/my-comps' );
	}
}